import { useFlags } from 'launchdarkly-react-client-sdk';

import { Routes } from './routes/Routes';
import { Routes as RoutesRevamp } from 'components/app/routes/RoutesRevamp';
import { Maintenance } from 'components/app/routes/Maintenance';
import { Feature } from 'components/common/feature/Feature';
import { useAnalytics } from 'analytics/useAnalytics';
import { ScrollToTop } from '../common/scroll-top/ScrollToTop';
import { useChatEvents } from 'analytics/useChatEvents';
import { useAuthentication } from 'hooks/useAuthentication';
import { useOnExit } from 'hooks/useOnExit';
import { DevMenu } from 'components/app/DevMenu';
import { useRevampJourney } from 'hooks/useRevampJourney';

const { VITE_BRANCH } = process.env;

export const testId = 'appTestId';

export const App = () => {
  const flags = useFlags();
  const { showApplicationMaintenanceMode } = flags;
  const { isRevampJourney } = useRevampJourney();
  useChatEvents();
  useAuthentication();
  useAnalytics();
  useOnExit();

  return (
    <div data-testid={testId}>
      <DevMenu viteBranch={VITE_BRANCH} />
      <ScrollToTop />
      <Feature
        feature={showApplicationMaintenanceMode}
        inactiveComponent={isRevampJourney ? <RoutesRevamp /> : <Routes />}
      >
        <Maintenance />
      </Feature>
    </div>
  );
};
